/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/

import { ThemingService } from '@windriver/ui';

export class PortalThemingService {
  currentTheme: string;

  constructor(themingService: ThemingService) {
    themingService.colorSchemeSubject.subscribe((theme) => {
      this.currentTheme = theme;
    });
  }

  get isDarkMode() {
    return this.currentTheme === 'dark';
  }

  get isLightMode() {
    return this.currentTheme === 'light';
  }
}
